<template>
	<div
		class="player-container"
		:class="{
			view_unpicked: view_options.unpicked,
			view_picked: view_options.picked,
			view_queue: view_options.queue,
		}"
	>
		<div
			v-for="(player, id) in players"
			:key="id"
			class="player"
			:class="{
				unpicked: !is_picked(id),
				picked: is_picked(id),
				queued: player.is_queued,
			}"
			@click="view_player(player, id)"
		>
			<span class="player-name">{{ player.name }}</span>
			<span class="player-position"
				>{{ player.position }} - {{ player.team }}</span
			>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.player-container {
	@apply overflow-y-auto;
	.player-name {
	}

	.player-position {
		@apply text-xs font-bold block;
	}

	.player {
		@apply border-collapse border-black border-t border-b;
		padding: 5px 10px;

		&:hover {
			background-color: #bdbdbd;
			cursor: pointer;
		}
	}

	.unpicked,
	.picked,
	.queue {
		display: none;
	}

	&.view_unpicked .unpicked {
		display: block;
	}

	&.view_picked .picked {
		display: block;
	}

	.picked.queued,
	.unpicked.queued {
		display: none;
	}

	&.view_queue .queued {
		display: block;
	}
}
</style>

<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters(['is_picked']),
	},
	props: {
		view_options: Object,
		players: Object,
		on_player_select: Function,
	},
	methods: {
		view_player(player, id) {
			this.on_player_select(player, id);
		},
	},
};
</script>
